/**
 * GHEAZON.COM — Custom JavaScript for Shopify Dawn Theme
 * 
 * USAGE: Add to Online Store > Themes > Edit Code > Assets
 * Then include in theme.liquid before </body>:
 * <script src="{{ 'gheazon-custom.js' | asset_url }}" defer></script>
 * 
 * Features:
 * - Scroll animations (Intersection Observer)
 * - Countdown timer
 * - Trust bar animation
 */

(function() {
  'use strict';

  /* ========== SCROLL ANIMATIONS ========== */
  const observerOptions = {
    threshold: 0.15,
    rootMargin: '0px 0px -50px 0px'
  };

  const animateOnScroll = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        animateOnScroll.unobserve(entry.target);
      }
    });
  }, observerOptions);

  document.querySelectorAll('.gheazon-animate').forEach((el) => {
    animateOnScroll.observe(el);
  });

  /* ========== COUNTDOWN TIMER ========== */
  function initCountdown() {
    const daysEl = document.getElementById('gheazon-countdown-days');
    const hoursEl = document.getElementById('gheazon-countdown-hours');
    const minsEl = document.getElementById('gheazon-countdown-mins');
    const secsEl = document.getElementById('gheazon-countdown-secs');

    if (!daysEl) return;

    // Set end date: 3 days from now (resets on each visit for urgency)
    let endDate = localStorage.getItem('gheazon_countdown_end');
    const now = Date.now();
    
    if (!endDate || parseInt(endDate) < now) {
      endDate = now + (3 * 24 * 60 * 60 * 1000);
      localStorage.setItem('gheazon_countdown_end', endDate.toString());
    } else {
      endDate = parseInt(endDate);
    }

    function updateCountdown() {
      const remaining = endDate - Date.now();
      
      if (remaining <= 0) {
        // Reset for 3 more days
        const newEnd = Date.now() + (3 * 24 * 60 * 60 * 1000);
        localStorage.setItem('gheazon_countdown_end', newEnd.toString());
        return;
      }

      const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
      const hours = Math.floor((remaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const mins = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
      const secs = Math.floor((remaining % (1000 * 60)) / 1000);

      daysEl.textContent = String(days).padStart(2, '0');
      hoursEl.textContent = String(hours).padStart(2, '0');
      minsEl.textContent = String(mins).padStart(2, '0');
      secsEl.textContent = String(secs).padStart(2, '0');
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  /* ========== ANNOUNCEMENT BAR ROTATION ========== */
  function initAnnouncementRotation() {
    const messages = document.querySelectorAll('.gheazon-announce__msg');
    if (messages.length < 2) return;

    let currentIndex = 0;
    messages[0].classList.add('active');

    setInterval(() => {
      messages[currentIndex].classList.remove('active');
      currentIndex = (currentIndex + 1) % messages.length;
      messages[currentIndex].classList.add('active');
    }, 4000);
  }

  /* ========== SMOOTH SCROLL FOR ANCHOR LINKS ========== */
  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', function(e) {
      const targetId = this.getAttribute('href');
      if (targetId === '#') return;
      
      const target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ========== LAZY STAGGER ANIMATION ========== */
  function initStaggerAnimation() {
    const containers = document.querySelectorAll('.gheazon-stagger');
    
    containers.forEach((container) => {
      const children = container.children;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            Array.from(children).forEach((child, index) => {
              setTimeout(() => {
                child.classList.add('visible');
              }, index * 100);
            });
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });

      observer.observe(container);
    });
  }

  /* ========== INIT ========== */
  document.addEventListener('DOMContentLoaded', function() {
    initCountdown();
    initAnnouncementRotation();
    initStaggerAnimation();
  });

})();
